export const PRODUCT_QUERY = `query Product($handle: String!) {
  product(handle: $handle) {
    title
    tags
    handle
    id
    onlineStoreUrl
    priceRange {
      minVariantPrice {
        amount
      }
    }
    options {
      name
      values
    }
    variants(first: 250) {
      edges {
        node {
          id
          product {
            id
            fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
              value
            }
          }
          quantityAvailable
          sku
          selectedOptions {
            value
            name
          }
          price {
            amount
          }
          compareAtPrice {
            amount
          }
          textBadge: metafield(namespace: "acf_pdp", key: "variant_badge_messaging") { value }
          shipsBy: metafield(namespace: "acf_variant", key: "ships_by") {
            value
          }
        }
      }
    }
    upsell_products: metafield(key: "upsell_products", namespace: "acf_pdp") {
      value
    }
    upgrade: metafield(key: "upgrade", namespace: "pdp") {
      reference {
        ... on Metaobject {
          text: field(key: "text"){
            value
          }
          product: field(key: "product"){
            value
          }
        }
      }
    }
    shortDescription: metafield(namespace: "acf_pdp", key: "romance_description_1") {
      value
    }
    textBadge: metafield(namespace: "acf_pdp", key: "badge_text_2") {
      value
    }
    imageBadge: metafield(namespace: "acf_pdp", key: "badge_asset") {
      value
    }
    fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
      value
    }
    promotedOptionGroups: metafield(key: "promoted_option_group", namespace: "acf_pdp") {
        references(first: 10) {
            nodes {
                ... on Metaobject {
                    pill: field(key: "discount_pill") {
                        value
                    }
                    tpr: field(key: "discount_amount") {
                        value
                    }
                    values: field(key: "promoted_option_values") {
                        value
                    }
                    label: field(key: "promoted_option_label") {
                        value
                    }
                    color: field(key: "promoted_option_label_color") {
                        value
                    }
                }
            }
        }
    }
  }
}`;

export const PRODUCT_STL_QUERY = `query STLProduct($handle: String!) {
  product(handle: $handle) {
    title
    variants(first: 250) {
      edges {
        node {
          id
          quantityAvailable
          image {
            url(
              transform: { maxWidth: 180 }
            )
            altText
          }
        }
      }
    }
  }
}`;

export const GALLERY_QUERY = `query ProductGallery($handle: String!) {
  product(handle: $handle) {
    media(first: 250) {
        edges {
            node {
                alt
                ... on MediaImage {
                    image {
                        url(
                            transform: { maxWidth: 768 }
                        )
                    }
                }
                ... on MediaImage {
                  zoom: image {
                      url(
                          transform: { maxWidth: 1600 }
                      )
                  }
                }
                ... on Video {
                    previewImage {
                        url(
                            transform: { maxWidth: 768 }
                        )
                    }
                    sources {
                        url
                        mimeType
                    }
                }
            }
        }
    }
    image_gallery_infographic: metafield(namespace: "custom", key: "infographic") {
      metaobjects: references(first: 10) {
        nodes {
          ... on Metaobject {
            id
            fields {
              key
              value

              object: reference {
                ... on MediaImage {
                  image {
                    id
                    url (transform: { maxWidth: 768 })
                    zoom: url (transform: { maxWidth: 1600 })
                  }
                }
              }
            }
          }
        }
      }
    }
    image_gallery_video: metafield(namespace: "custom", key: "image_gallery_video") {
      metaobjects: references(first: 10) {
        nodes {
          ... on Metaobject {
            fields {
              key
              value

              object: reference {
                ... on MediaImage {
                  image {
                    id
                    url
                  }
                }
                ... on GenericFile {
                  url
                }
              	... on Video {
                  sources {
                    url
                  }
                  previewImage {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`;

export const ALIASES_QUERY = `query ProductAliases($handle: String!) {
    product(handle: $handle) {
        metafield(namespace: "custom", key: "option_aliases") {
            references(first: 20) {
                nodes {
                    ... Aliases
                }
            }
        }
    }
} fragment Aliases on Metaobject {
    aliases: field(key: "aliases") {
        value
    }
    option: field(key: "option_value") {
        value
    }
}`;

export const COMPONENT_FROM_SELECTIONS_QUERY = `query bundleItem($handle: String!, $options: [SelectedOptionInput!]!) {
  product(handle: $handle) {
    title
    tags
    handle
    variantBySelectedOptions(selectedOptions: $options) {
	    ...variant
    }
    variants(first:1) {
      edges {
        node {
          ...variant
        }
      }
    }
    promotedOptionGroups: metafield(key: "promoted_option_group", namespace: "acf_pdp") {
        references(first: 10) {
            nodes {
                ... on Metaobject {
                    pill: field(key: "discount_pill") {
                        value
                    }
                    tpr: field(key: "discount_amount") {
                        value
                    }
                    values: field(key: "promoted_option_values") {
                        value
                    }
                    label: field(key: "promoted_option_label") {
                        value
                    }
                    color: field(key: "promoted_option_label_color") {
                        value
                    }
                }
            }
        }
    }
  }
}

fragment variant on ProductVariant {
  id
  product {
    id
    fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
      value
    }
  }
  sku
  price {
    amount
  }
  title
  compareAtPrice {
    amount
  }
  textBadge: metafield(namespace: "acf_pdp", key: "variant_badge_messaging") { value }
  quantityAvailable
  image {
    url(
      transform: { maxWidth: 768 }
    )
    altText
  }
  zoom: image {
        url(
            transform: { maxWidth: 1600 }
        )
    }
  selectedOptions {
    name
    value
  }
  shipsBy: metafield(namespace: "acf_variant", key: "ships_by") {
    value
  }
}`;

export const OPTION_MESSAGING_QUERY = `query OptionMessaging($handle: String!) {
product(handle: $handle) {
    location: metafield(namespace: "acf_pdp", key: "option_messaging_location") {
        value
    }
    messaging: metafield(namespace: "acf_pdp", key: "option_list_messaging") {
        value
    }
}`;

export const UPSELL_ITEM = `query Product($handle: String!) {
  product(handle: $handle) {
    title
    tags
    handle
    id
    options {
      name
      values
    }
    variants(first: 250) {
      edges {
        node {
          ...variant
        }
      }
    }
    shortDescription: metafield(namespace: "acf_pdp", key: "romance_description_1") {
      value
    }
    fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
      value
    }
  }
}
fragment variant on ProductVariant {
  id
  sku
  price {
    amount
  }
  compareAtPrice {
    amount
  }
  quantityAvailable
  image {
    url(
      transform: { maxWidth: 128 }
    )
    altText
  }
  selectedOptions {
    name
    value
  }
  shipsBy: metafield(namespace: "acf_variant", key: "ships_by") {
    value
  }
}`;

export const SECONDARY_PRODUCTS_QUERY = `query SecondaryProducts($handle: String!) {
  product(handle: $handle) {
    handles: metafield(key: "secondary_product", namespace: "acf_pdp") {
      value
    }
    labels: metafield(key: "secondary_product_label", namespace: "acf_pdp") {
      value
    }
    limits: metafield(key: "secondary_product_limit", namespace: "acf_pdp") {
      value
    }
    merged: metafield(key: "merge_secondary_options", namespace: "acf_pdp") {
      value
    }
  }
}`;

export const UPGRADE_ITEM = `query Product($id: ID!) {
  product(id: $id) {
      onlineStoreUrl
      title
  }
}`;
